import { useState } from "react";
import cn from "classnames";
import Dropdown from "../Dropdown";

interface Props {
  content: React.ReactNode;
  children: React.ReactNode;
  direction?: "bottom" | "top";
  align?: "left" | "right";
  width?: string;
  className?: string;
  contentClassName?: string;
}

export default function Tooltip({
  content,
  children,
  direction = "bottom",
  align = "left",
  width = "w-max",
  className,
  contentClassName,
}: Props) {
  const [open, setOpen] = useState(false);

  function handleOpen() {
    setOpen(true);
  }

  function handleClose() {
    setOpen(false);
  }

  return (
    <div
      className={cn("relative inline-flex items-center", className)}
      tabIndex={0}
      onMouseEnter={handleOpen}
      onMouseLeave={handleClose}
      onFocus={handleOpen}
      onBlur={handleClose}>
      <Dropdown
        open={open}
        onClose={handleClose}
        direction={direction}
        align={align}
        width={width}
        className="elevation-level-2!">
        {children}
        <div
          className={cn("p-2", contentClassName)}
          onMouseEnter={handleOpen}
          onMouseLeave={handleClose}>
          {content}
        </div>
      </Dropdown>
    </div>
  );
}
